import React from 'react';

interface AppPageProps {
    /** Optional page title rendered in the header bar. */
    title?: string;
    /** Optional subtitle rendered next to the title in the header bar. */
    subtitle?: string;
    /** Optional controls (buttons, filters, etc.) right-aligned in the header bar. */
    headerActions?: React.ReactNode;
    /** Extra class applied to the root `.app-page` element. */
    className?: string;
    children?: React.ReactNode;
}

/**
 * Base layout for every non-canvas page rendered inside AppShell (Insights,
 * Plan, and any future page). Provides the shared `.app-page` root, an
 * optional header row (title / subtitle / actions), and the `.app-page-body`
 * flex row that panels are placed into. New pages should build on this
 * instead of hand-rolling the `.app-page` / `.app-page-body` wrapper.
 */
export default function AppPage({ title, subtitle, headerActions, className = '', children }: AppPageProps) {
    const hasHeader = Boolean(title || subtitle || headerActions);

    return (
        <div className={`app-page ${className}`.trim()}>
            {hasHeader && (
                <div className='app-page-header'>
                    {title && <h1 className='app-page-title'>{title}</h1>}
                    {subtitle && <p className='app-page-subtitle'>{subtitle}</p>}
                    {headerActions && <div className='app-page-header-actions'>{headerActions}</div>}
                </div>
            )}
            <div className='app-page-body'>{children}</div>
        </div>
    );
}
